module.exports = __webpack_public_path__ + "img/بنر متحرک (گیف).924ab8b3.gif";